import { render, staticRenderFns } from "./costlossManage.vue?vue&type=template&id=12033f28"
import script from "./costlossManage.vue?vue&type=script&lang=js"
export * from "./costlossManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12033f28')) {
      api.createRecord('12033f28', component.options)
    } else {
      api.reload('12033f28', component.options)
    }
    module.hot.accept("./costlossManage.vue?vue&type=template&id=12033f28", function () {
      api.rerender('12033f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/costloss/costlossManage.vue"
export default component.exports